import React, { useState, useEffect, useMemo, useCallback } from "react";
import { ToastContainer } from "react-toastify";
import Select from "react-select";
import swal from "sweetalert";
import { Button, Modal } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import PageTitle from "../../../layouts/PageTitle";
import CommonService from "../../../../services/Common/CommonService";
import useFullPageLoader from "../../../../hooks/useFullPageLoader";
import {
  restApi,
  restApi_PD,
} from "../../../../services/wooCommerceRestApi/restApi";
import Table from "../../../components/table/ReactTable/Table";
import { ColumnFilter } from "../../../components/table/ReactTable/ColumnFilter";
import { Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import { termActions, masterActions } from "../../../../_store";
import Toastr from "../../../components/common/Toastr";
import generatePDF from "../../../components/export/generatePDF";
import generateXlsx from "../../../components/export/generateXlsx";

const Terms = () => {
  const dispatch = useDispatch();
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  // #region Reducers ------------------  Reducers --------------------------------

  const currentUser = useSelector((x) => x.auth.user);
  const termList = useSelector((x) => x.term.termList);
  const term = useSelector((x) => x.term.term);
  const termResponse = useSelector((x) => x.term.termResponse);
  const deleteTermResponse = useSelector((x) => x.term.deleteTermResponse);
  const attributeDrpList = useSelector((x) => x.master.attributeDrpList);
  const isLoading = useSelector((x) => x.term.isLoading);

  // #endregion Reducers ------------------  Reducers End --------------------------------
  const terms_COLUMNS = [
    {
      Header: "Attribute",
      Footer: "Attribute",
      accessor: "AttributeName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Terms",
      Footer: "Terms",
      accessor: "TermName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Website",
      Footer: "Website",
      accessor: "Woocommerce",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Status",
      Footer: "Status",
      accessor: "StatusName",
      justify: "center",
      Cell: ({ value }) => {
        return (
          <>
            <Badge variant="primary light badge-lg"> {value}</Badge>
          </>
        );
      },
      Filter: ColumnFilter,
    },
    {
      Header: "",
      Footer: "",
      accessor: "TermID",
      disableFilters: true,
      Cell: ({ row }) => {
        return (
          <>
            <div className="d-flex">
              <Link
                onClick={() => handleEditClick(row.original)}
                className="btn btn-primary shadow btn-xs sharp me-1"
                title="Edit"
              >
                <i className="fas fa-pen"></i>
              </Link>
              <Link
                onClick={() => handleDeleteClick(row.original)}
                className="btn btn-danger shadow btn-xs sharp"
                title="Delete"
              >
                <i className="fa fa-trash"></i>
              </Link>
            </div>
          </>
        );
      },
    },
  ];

  const columns = useMemo(() => terms_COLUMNS, []);
  const generateColumns = [
    {
      header: " Attribute",
      dataKey: "AttributeName",
    },
    {
      header: "Terms",
      dataKey: "TermName",
    },

    {
      header: "Website",
      dataKey: "Woocommerce",
    },
    {
      header: "Status",
      dataKey: "StatusName",
    },
  ];

  const [isOpenModal, setOpenModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [finalTableData, setFinalTableData] = useState([]);

  const handleTableDataUpdate = useCallback((data) => {
    setFinalTableData(data);
  }, []);

  const [wordPressData, setWordPressData] = useState({
    source_url: "",
  });
  let styles = {
    control: (styles) => ({ ...styles, border: "1px solid red" }),
  };

  //Add data
  const [addFormData, setAddFormData] = useState({
    AttributeID: 0,
    WCAttributeID: 0,
    TermID: 0,
    WCTermID: 0,
    PDWCTermID: 0,
    TermName: "",
    AttributeName: "",
    Slug: "",
    Description: "",
    AttributeOption: null,
    Status: 1,
    IsGemar: false,
    IsPartyDeco: false,
    CreatedBy: currentUser.Id,
  });

  const newFormData = { ...addFormData };

  useEffect(() => {
    showLoader();
    let AttributeID = 0;
    let Status = 1;
    dispatch(masterActions.GetAttributeDrpList({ AttributeID, Status }));
    dispatch(termActions.getTermAll());
  }, [dispatch]);

  useEffect(() => {
    if (isLoading) {
      hideLoader();
    }
  }, [isLoading]);

  const handleChkBoxChangeWooCom = (event) => {
    const { name, checked } = event.target;

    setAddFormData((newFormData) => ({
      ...newFormData,
      [name]: checked ? true : false,
    }));
  };

  // handle Change function
  const handleChange = (event) => {
    event.preventDefault();
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    if (fieldValue && fieldValue.trim()) {
      newFormData[fieldName] = fieldValue;
    } else {
      newFormData[fieldName] = fieldValue.trim();
    }

    setAddFormData(newFormData);
  };

  // handle Dropdown Change function
  const handleDrpChange = (event, title) => {
    newFormData[title] = event.value && parseInt(event.value);
    if (title === "AttributeID") {
      newFormData.AttributeOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    }
    setAddFormData(newFormData);
  };

  // Edit Term
  useEffect(() => {
    if (term && term.TermID > 0) {
      newFormData.TermID = term.TermID;
      newFormData.WCTermID = term.WCTermID;
      newFormData.PDWCTermID = term.PDWCTermID;
      newFormData.AttributeID = term.AttributeID;
      newFormData.TermName = term.TermName;
      newFormData.Slug = term.Slug;
      newFormData.Description = term.Description;
      newFormData.IsGemar = term.IsGemar;
      newFormData.IsPartyDeco = term.IsPartyDeco;
      newFormData.Status = term.Status;
      newFormData.AttributeOption = {
        value: term.TermID,
        label: term.AttributeName,
      };

      setAddFormData(newFormData);
    }
  }, [term]);

  // Submit data function
  const handleSubmit = (event) => {
    event.preventDefault();
    var error = false;
    if (
      !addFormData.TermName ||
      (addFormData.IsGemar === false && addFormData.IsPartyDeco === false)
    ) {
      error = true;

      if (newFormData.IsGemar === false && newFormData.IsPartyDeco === false) {
        error = true;
      }
    }
    if (!error) {
      let attributeList = attributeDrpList.filter(
        (d) => d.value === newFormData.AttributeID
      );
      let WCParentId = 0;
      let pdWCParentId = 0;
      let termIsGemar = false;
      let termIsPartyDeco = false;
      if (attributeList && attributeList[0]) {
        let termDetail = attributeList && attributeList[0] && attributeList[0];
        WCParentId = termDetail.wcid;
        pdWCParentId = termDetail.pdWcid;
        termIsGemar = termDetail.IsGemar;
        termIsPartyDeco = termDetail.IsPartyDeco;
      }
      if (
        (newFormData.IsGemar === true &&
          newFormData.IsPartyDeco === false &&
          WCParentId &&
          parseInt(WCParentId) > 0) ||
        (newFormData.IsPartyDeco === true &&
          newFormData.IsGemar === false &&
          pdWCParentId &&
          parseInt(pdWCParentId) > 0) ||
        (newFormData.IsPartyDeco === true &&
          newFormData.IsGemar === true &&
          WCParentId &&
          parseInt(WCParentId) > 0 &&
          pdWCParentId &&
          parseInt(pdWCParentId) > 0)
      ) {
        if (newFormData.TermID > 0) {
          showLoader();

          let gemar_data = {
            name: newFormData.TermName,
            description: newFormData.Description,
            // slug: newFormData.Slug,
            // description: newFormData.Description,
          };
          let PD_data = {
            name: newFormData.TermName,
            description: newFormData.Description,
            // slug: newFormData.Slug,
            // description: newFormData.Description,
          };
          // let attribute_id = WCParentId
          if (
            addFormData.IsGemar === true &&
            addFormData.IsPartyDeco === true
          ) {
            if (newFormData.WCTermID > 0 && newFormData.PDWCTermID > 0) {
              UpdateTerms_GemarAndPD(
                gemar_data,
                PD_data,
                WCParentId,
                pdWCParentId
              );
            } else if (newFormData.WCTermID > 0) {
              UpdateTerms_UpdateGemarAndAddPD(
                gemar_data,
                PD_data,
                WCParentId,
                pdWCParentId
              );
            } else if (newFormData.PDWCTermID > 0) {
              UpdateTerms_AddGemarAndUpdatePD(
                gemar_data,
                PD_data,
                WCParentId,
                pdWCParentId
              );
            }
          } else if (addFormData.IsGemar === true) {
            UpdateTerms_Gemar(gemar_data, WCParentId);
          } else if (addFormData.IsPartyDeco === true) {
            UpdateTerms_PD(PD_data, pdWCParentId);
          }
        } else {
          showLoader();
          let gemar_data = {
            name: newFormData.TermName,
            description: newFormData.Description,
          };
          let PD_data = {
            name: newFormData.TermName,
            description: newFormData.Description,
          };

          if (
            addFormData.IsGemar === true &&
            addFormData.IsPartyDeco === true
          ) {
            AddTerms_GemarAndPD(gemar_data, PD_data, WCParentId, pdWCParentId);
          } else if (addFormData.IsGemar === true) {
            AddTerms_Gemar(gemar_data, WCParentId);
          } else if (addFormData.IsPartyDeco === true) {
            AddTerms_PD(PD_data, pdWCParentId);
          }
        }
      } else {
        hideLoader();
        setSubmitted(true);
        Toastr(
          "Please check attribute for  Gemar and PartyDeco must same term",
          "warning"
        );
      }
    } else {
      hideLoader();
      setSubmitted(true);
      Toastr("Please fill in the required missing fields", "warning");
    }
  };

  // Migration fun
  /* const handleMigrationSubmit = (event) => {
    newFormData.PDWCTermID = 0;
    newFormData.WCTermID = 0;
    dispatch(termActions.saveTerm(newFormData));
  }; */

  //----InsertTerms Gemar & Party Deco------------

  function AddTerms_GemarAndPD(gemar_data, PD_data, WCParentId, pdWCParentId) {
    restApi
      .post("products/attributes/" + WCParentId + "/terms", gemar_data) // Gemar API
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          newFormData.WCTermID = response.data.id;

          restApi_PD
            .post("products/attributes/" + pdWCParentId + "/terms", PD_data) // Party Deco API
            .then((PDResponse) => {
              console.log(PDResponse.data);
              if (
                PDResponse.status === 200 ||
                PDResponse.status === 201 ||
                !PDResponse.statusText
              ) {
                newFormData.PDWCTermID = PDResponse.data.id;
                dispatch(termActions.saveTerm(newFormData));
              } else {
                hideLoader();
                Toastr(PDResponse.statusText, "warning");
              }
            })
            .catch((error) => {
              hideLoader();
              let msg = "";
              if (error.response) {
                if (error.response.data.code === "term_exists") {
                  msg = "Party Deco Term  already exists";
                } else {
                  msg = error.response.data.message;
                }
              } else {
                msg = "rest Api error";
              }
              Toastr(msg, "warning");
              console.log();
            });
        } else {
          hideLoader();
          Toastr(response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Gemar Terms  already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }

  function AddTerms_Gemar(gemar_data, WCParentId) {
    restApi
      .post("products/attributes/" + WCParentId + "/terms/", gemar_data) // Gemar API
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          newFormData.WCTermID = response.data.id;
          if (newFormData.TermID === 0 || !newFormData.TermID) {
            newFormData.PDWCTermID = 0;
          }
          dispatch(termActions.saveTerm(newFormData));
        } else {
          hideLoader();
          Toastr(response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Gemar Terms already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "Gemar Terms rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }

  function AddTerms_PD(PD_data, pdWCParentId) {
    restApi_PD
      .post("products/attributes/" + pdWCParentId + "/terms", PD_data) // Party Deco API
      .then((PDResponse) => {
        console.log(PDResponse.data);
        if (
          PDResponse.status === 200 ||
          PDResponse.status === 201 ||
          !PDResponse.statusText
        ) {
          newFormData.PDWCTermID = PDResponse.data.id;
          if (newFormData.TermID === 0 || !newFormData.TermID) {
            newFormData.WCTermID = 0;
          }

          dispatch(termActions.saveTerm(newFormData));
        } else {
          hideLoader();
          Toastr(PDResponse.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Party Deco Terms name already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "Party Deco : rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }

  //---- Update Terms Gemar & Party Deco------------

  function UpdateTerms_GemarAndPD(
    gemar_data,
    PD_data,
    WCParentId,
    pdWCParentId
  ) {
    restApi
      .put(
        "products/attributes/" + WCParentId + "/terms/" + newFormData.WCTermID,
        gemar_data
      ) // Gemar API
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          newFormData.WCTermID = response.data.id;
          restApi_PD
            .put(
              "products/attributes/" +
                pdWCParentId +
                "/terms/" +
                newFormData.PDWCTermID,
              PD_data
            ) // Party Deco API
            .then((PDResponse) => {
              console.log(PDResponse.data);
              if (
                PDResponse.status === 200 ||
                PDResponse.status === 201 ||
                !PDResponse.statusText
              ) {
                newFormData.PDWCTermID = PDResponse.data.id;

                // Core WMS API
                dispatch(termActions.saveTerm(newFormData));
              } else {
                hideLoader();
                Toastr("Party Deco :" + PDResponse.statusText, "warning");
              }
            })
            .catch((error) => {
              hideLoader();
              let msg = "";
              if (error.response) {
                if (error.response.data.code === "term_exists") {
                  msg = "Party Deco Terms  already exists";
                } else {
                  msg = error.response.data.message;
                }
              } else {
                msg = "Party Deco rest Api error";
              }
              Toastr(msg, "warning");
              console.log();
            });
        } else {
          hideLoader();
          Toastr("Party Deco :" + response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Gemar Terms  already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "Gemar rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }

  function UpdateTerms_UpdateGemarAndAddPD(
    gemar_data,
    PD_data,
    WCParentId,
    pdWCParentId
  ) {
    restApi
      .put(
        "products/attributes/" + WCParentId + "/terms/" + newFormData.WCTermID,
        gemar_data
      ) // Gemar API
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          newFormData.WCTermID = response.data.id;

          // Add PD
          AddTerms_PD(PD_data, pdWCParentId);
        } else {
          hideLoader();
          Toastr("Gemar Deco :" + response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Gemar Terms  already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "Gemar rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }

  function UpdateTerms_AddGemarAndUpdatePD(
    gemar_data,
    PD_data,
    WCParentId,
    pdWCParentId
  ) {
    restApi_PD
      .put(
        "products/attributes/" +
          pdWCParentId +
          "/terms/" +
          newFormData.PDWCTermID,
        PD_data
      ) // Party Deco API
      .then((PDResponse) => {
        console.log(PDResponse.data);
        if (
          PDResponse.status === 200 ||
          PDResponse.status === 201 ||
          !PDResponse.statusText
        ) {
          newFormData.PDWCTermID = PDResponse.data.id;

          // Add gemar
          AddTerms_Gemar(gemar_data, WCParentId);
        } else {
          hideLoader();
          Toastr("Party Deco :" + PDResponse.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Party Deco Terms  already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "Party Deco rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }
  function UpdateTerms_Gemar(gemar_data, WCParentId) {
    restApi
      .put(
        "products/attributes/" + WCParentId + "/terms/" + newFormData.WCTermID,
        gemar_data
      ) // Gemar API
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          newFormData.WCTermID = response.data.id;
          // Core WMS API
          dispatch(termActions.saveTerm(newFormData));
        } else {
          hideLoader();
          Toastr("Gemar :" + response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Gemar Term already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "Gemar rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }
  function UpdateTerms_PD(PD_data, pdWCParentId) {
    restApi_PD
      .put(
        "products/attributes/" +
          pdWCParentId +
          "/terms/" +
          newFormData.PDWCTermID,
        PD_data
      ) // Party Deco API
      .then((PDResponse) => {
        console.log(PDResponse.data);
        if (
          PDResponse.status === 200 ||
          PDResponse.status === 201 ||
          !PDResponse.statusText
        ) {
          newFormData.PDWCTermID = PDResponse.data.id;

          // Core WMS API
          dispatch(termActions.saveTerm(newFormData));
        } else {
          hideLoader();
          Toastr("Party Deco :" + PDResponse.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Party Deco Terms  already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "Party Deco rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }
  //----------end Update Terms Gemar & Party Deco------------

  const handlePoupClick = () => {
    newFormData.AttributeID = newFormData.TermID = 0;
    newFormData.TermName =
      newFormData.AttributeID =
      newFormData.Slug =
      newFormData.Description =
        "";
    newFormData.AttributeOption = null;
    newFormData.Status = 1;
    newFormData.IsGemar = newFormData.IsPartyDeco = false;
    setAddFormData(newFormData);
    setOpenModal(true);
    setSubmitted(false);
  };

  // Term Add And Update  handleSubmit //
  useEffect(() => {
    if (termResponse === 1) {
      hideLoader();
      Toastr("Term Successfully Added", "success");
      dispatch(termActions.getTermAll());
      setOpenModal(false);
    } else if (termResponse === 2) {
      hideLoader();
      Toastr(" Term Successfully Updated", "success");
      dispatch(termActions.getTermAll());
      setOpenModal(false);
    } else if (termResponse === -1) {
      hideLoader();
      Toastr("Term already exists ", "warning");
    }
  }, [termResponse]);

  const handleEditClick = (values) => {
    dispatch(termActions.getTermById({ TermID: values.TermID }));
    setOpenModal(true);
    setSubmitted(false);
  };

  // handle Check Box Click function
  const handleCkBoxChange = (event, title) => {
    let hasChecked = event.target.checked === true ? 1 : 2;
    if (!event.target.checked && newFormData.TermID && newFormData.TermID > 0) {
      showLoader();

      let Param = { DeleteID: newFormData.TermID, DeleteType: 4 };
      CommonService.CheckMappedItem(Param).then((res) => {
        if (res.data === 1) {
          newFormData[title] = hasChecked;
          setAddFormData(newFormData);
          hideLoader();
        } else {
          Toastr("This Term is already mapped", "warning");
          hideLoader();
        }
      });
    } else {
      newFormData[title] = hasChecked;
      setAddFormData(newFormData);
    }
  };

  const handleDeleteClick = (values) => {
    swal({
      title: "Are you sure, you want to delete this Term?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoader();

        let Param = { DeleteID: values.TermID, DeleteType: 4 };
        CommonService.CheckMappedItem(Param).then((res) => {
          if (res.data === 1) {
            if (values.IsGemar === true && values.IsPartyDeco === true) {
              restApi
                .delete(
                  "products/attributes/" +
                    values.WCAttributeID +
                    "/terms/" +
                    values.WCTermID,
                  {
                    // Gemar API
                    force: true,
                  }
                )
                .then((response) => {
                  console.log(response.data);
                  if (
                    response.status === 200 ||
                    response.status === 201 ||
                    !response.statusText
                  ) {
                    // Party Deco API
                    restApi_PD
                      .delete(
                        "products/attributes/" +
                          values.PDWCAttributeID +
                          "/terms/" +
                          values.PDWCTermID,
                        {
                          force: true,
                        }
                      )
                      .then((PDResponse) => {
                        if (
                          PDResponse.status === 200 ||
                          PDResponse.status === 201 ||
                          !PDResponse.statusText
                        ) {
                          // Core API
                          dispatch(
                            termActions.deleteTerm({
                              TermID: values.TermID,
                              DeletedBy: currentUser.Id,
                            })
                          );
                        } else {
                          Toastr(
                            "Party Deco : " + response.statusText,
                            "warning"
                          );
                          hideLoader();
                        }
                      })
                      .catch((error) => {
                        hideLoader();
                        Toastr(
                          error.response
                            ? error.response.data.message
                            : "rest Api error",
                          "warning"
                        );
                        console.log(error.response && error.response.data);
                      });
                  } else {
                    Toastr("Gemar : " + response.statusText, "warning");
                    hideLoader();
                  }
                })
                .catch((error) => {
                  hideLoader();
                  Toastr(
                    error.response
                      ? error.response.data.message
                      : "rest Api error",
                    "warning"
                  );
                  console.log(error.response && error.response.data);
                });
            } else if (values.IsGemar === true) {
              // Gemar API
              restApi
                .delete(
                  "products/attributes/" +
                    values.WCAttributeID +
                    "/terms/" +
                    values.WCTermID,
                  {
                    // Gemar API
                    force: true,
                  }
                )
                .then((response) => {
                  console.log(response.data);
                  if (
                    response.status === 200 ||
                    response.status === 201 ||
                    !response.statusText
                  ) {
                    // Core API
                    dispatch(
                      termActions.deleteTerm({
                        TermID: values.TermID,
                        DeletedBy: currentUser.Id,
                      })
                    );
                  } else {
                    Toastr(response.statusText, "warning");
                    hideLoader();
                  }
                })
                .catch((error) => {
                  hideLoader();
                  Toastr(
                    error.response
                      ? error.response.data.message
                      : "rest Api error",
                    "warning"
                  );
                  console.log(error.response && error.response.data);
                });
            } else if (values.IsPartyDeco === true) {
              // Party Deco API
              restApi_PD
                .delete(
                  "products/attributes/" +
                    values.PDWCAttributeID +
                    "/terms/" +
                    values.PDWCTermID,
                  {
                    force: true,
                  }
                )
                .then((response) => {
                  console.log(response.data);
                  if (
                    response.status === 200 ||
                    response.status === 201 ||
                    !response.statusText
                  ) {
                    // Core API
                    dispatch(
                      termActions.deleteTerm({
                        TermID: values.TermID,
                        DeletedBy: currentUser.Id,
                      })
                    );
                  } else {
                    Toastr(response.statusText, "warning");
                    hideLoader();
                  }
                })
                .catch((error) => {
                  hideLoader();
                  Toastr(
                    error.response
                      ? error.response.data.message
                      : "rest Api error",
                    "warning"
                  );
                  console.log(error.response && error.response.data);
                });
            }
          } else {
            Toastr("This Term is already mapped", "warning");
            hideLoader();
          }
        });
      }
    });
  };

  // handleDeleteClick
  useEffect(() => {
    if (deleteTermResponse === 1) {
      hideLoader();
      Toastr("Successfully Deleted", "success");
      dispatch(termActions.getTermAll());
    } else if (deleteTermResponse === -1) {
      hideLoader();
      Toastr("Error ", "warning");
    } else {
      // hideLoader();
    }
  }, [deleteTermResponse]);

  const handleClickPDF = () => {
    let title = "Term List";
    const columnStyles = {
      AttributeName: { halign: "left", cellWidth: 90 },
      TermName: { halign: "left", cellWidth: 90 },
      StatusName: { halign: "center", cellWidth: 30 },
      Woocommerce: { halign: "left", cellWidth: 50 },
    };
    generatePDF(finalTableData, generateColumns, true, title, columnStyles);
  };

  const handleClickExcel = () => {
    let title = "Term";
    let generateExcelColumns = ["Attribute", "Terms", "Website", "Status"];
    let new_termList =
      finalTableData &&
      finalTableData.map(function (obj) {
        return {
          AttributeName: obj.AttributeName,
          Terms: obj.TermName,
          // Slug: obj.Slug,
          Woocommerce: obj.Woocommerce,
          StatusName: obj.StatusName,
        };
      });

    generateXlsx(new_termList, generateExcelColumns, title);
  };

  const handleClosePopup = () => {
    dispatch(termActions.clearTermResponse());
    setOpenModal(false);
  };

  return (
    <>
      <PageTitle activeMenu="Terms" motherMenu="Master" />
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">Terms List</h4>
          <div className="float-sm-end">
            {termList && termList.length > 0 && (
              <>
                <Button
                  className="me-2"
                  variant="danger btn-rounded"
                  onClick={handleClickPDF}
                >
                  <span className="btn-icon-start text-danger">
                    <i className="fa fa-solid fa-file-pdf"></i>
                    {/* <i className="fa fa-regular fa-file-excel"></i> */}
                  </span>
                  PDF
                </Button>
                <Button
                  className="me-2"
                  variant="secondary btn-rounded"
                  onClick={handleClickExcel}
                >
                  <span className="btn-icon-start text-secondary">
                    {/* <i className="fa fa-solid fa-file-pdf"></i> */}
                    <i className="fa fa-regular fa-file-excel"></i>
                  </span>
                  Excel
                </Button>
              </>
            )}
            <Button
              className="me-2"
              variant="primary btn-rounded"
              onClick={handlePoupClick}
            >
              <span className="btn-icon-start text-primary">
                <i className="fa fa-plus color-info" />
              </span>
              Add
            </Button>
          </div>
        </div>
        <div className="card-body">
          <Table
            columns={columns}
            data={termList}
            onDataUpdate={handleTableDataUpdate}
          />
        </div>
      </div>

      {/* <!-- Modal --> */}
      <Modal className="fade bd-example-modal-lg" show={isOpenModal} size="lg">
        <Modal.Header>
          <Modal.Title>
            {newFormData.TermID > 0 ? "Edit Term" : "Add Term"}
          </Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => handleClosePopup()}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-6 mb-3">
                <div className="contact-name">
                  <label className="text-black font-w500">
                    Attribute Name<span className="text-danger">*</span>
                  </label>
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="AttributeID"
                    value={newFormData.AttributeOption}
                    options={attributeDrpList}
                    onChange={(event) => handleDrpChange(event, "AttributeID")}
                    styles={
                      (submitted && !newFormData.AttributeID) ||
                      newFormData.AttributeID === 0
                        ? styles
                        : ""
                    }
                    isDisabled={newFormData.TermID > 0 ? true : false}
                  />

                  <span className="validation-text"></span>
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  Term Name<span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${
                      submitted && !addFormData.TermName && "border-danger"
                    }`}
                    autocomplete="off"
                    value={newFormData.TermName}
                    name="TermName"
                    required="required"
                    onChange={handleChange}
                    placeholder="Term Name"
                    maxLength={50}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
            </div>

            <div className="row">
              {/* <div className="col-md-6 mb-3">
                                <label className="text-black font-w500">Slug</label>
                                <div className="contact-name">
                                    <input type="text" className={`form-control`} autocomplete="off"
                                        name="Slug" required="required"
                                        value={newFormData.Slug}
                                        onChange={handleChange}
                                        placeholder="Slug"
                                        maxLength={50}
                                    />
                                    <span className="validation-text"></span>
                                </div>
                            </div> */}
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">Description</label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control`}
                    autocomplete="off"
                    name="Description"
                    required="required"
                    value={newFormData.Description}
                    onChange={handleChange}
                    placeholder="Description"
                    maxLength={50}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="text-black font-w500"></label>
                {newFormData.TermID > 0 ? (
                  // Update
                  <div className="contact-name">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckGemar"
                      name="IsGemar"
                      checked={addFormData.IsGemar === true}
                      disabled={
                        newFormData.TermID > 0 && newFormData.WCTermID > 0
                      }
                      onChange={(event) => handleChkBoxChangeWooCom(event)}
                    />
                    <label
                      className="form-check-label font-w600"
                      htmlFor="flexSwitchCheckGemar"
                    >
                      Gemar
                    </label>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckPartyDeco"
                        name="IsPartyDeco"
                        checked={addFormData.IsPartyDeco === true}
                        disabled={
                          newFormData.TermID > 0 && newFormData.PDWCTermID > 0
                        }
                        onChange={(event) => handleChkBoxChangeWooCom(event)}
                      />
                      <label
                        className="form-check-label font-w600"
                        htmlFor="flexSwitchCheckPartyDeco"
                      >
                        PartyDeco
                      </label>
                    </div>
                  </div>
                ) : (
                  // Add
                  <div className="contact-name">
                    <input
                      className={`form-check-input ${
                        submitted &&
                        addFormData.IsGemar === false &&
                        addFormData.IsPartyDeco === false &&
                        "border-danger"
                      }`}
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckGemar"
                      name="IsGemar"
                      checked={addFormData.IsGemar === true}
                      onChange={(event) => handleChkBoxChangeWooCom(event)}
                    />
                    <label
                      className="form-check-label font-w600"
                      htmlFor="flexSwitchCheckGemar"
                    >
                      Gemar
                    </label>
                    <div className="form-check">
                      <input
                        className={`form-check-input ${
                          submitted &&
                          addFormData.IsGemar === false &&
                          addFormData.IsPartyDeco === false &&
                          "border-danger"
                        }`}
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckPartyDeco"
                        name="IsPartyDeco"
                        checked={addFormData.IsPartyDeco === true}
                        onChange={(event) => handleChkBoxChangeWooCom(event)}
                      />
                      <label
                        className="form-check-label font-w600"
                        htmlFor="flexSwitchCheckPartyDeco"
                      >
                        PartyDeco
                      </label>
                    </div>
                  </div>
                )}
              </div>

              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">Active</label>
                <div>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckDefault"
                      name="Status"
                      checked={newFormData.Status === 1 ? true : false}
                      onChange={(event) => handleCkBoxChange(event, "Status")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger light" onClick={() => handleClosePopup()}>
            Close
          </Button>
          <Button
            variant=""
            //  onClick={() => setLargeModal(false)}
            onClick={handleSubmit}
            //  onClick={handleMigrationSubmit}
            className="btn btn-primary"
          >
            {newFormData.TermID > 0 ? "Update" : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>

      {loader}
    </>
  );
};

export default Terms;
